<template>
  <c-container>
    <p>予約をキャンセル</p>
  </c-container>
</template>

<script>
import page from '@/mixins/page'

export default {
  name: 'Cancel',
  mixins: [
    page('予約をキャンセル')
  ]
}
</script>
